import { apiClientPath } from '../../constants/const';
import React, { useState } from 'react';
import {
    Routes,
    Route,
    Navigate,
    BrowserRouter
  } from "react-router-dom";
import Login from './Login';
import './App.css';
import '../MainMenu/MainMenu.css';
import '../AllgemeineCss/Farben.css';
import '../AllgemeineCss/Abstände.css';
import useToken from './useToken';
import GeneralFooter from '../Footer/footer';
import Stammdaten from '../Stammdaten/Stammdaten';
import KeinZugriff from '../MainMenu/Zugriffsrecht';
import Reporting from '../Reporting/Reporting';
import Support from '../Support/Support';
import Datenerfassung from '../Datenerfassung/Daten';
import GeneralHander from '../hander/hander';
import MainJahr from '../Jahrszahlen/MainJahr';
import MainLinie from '../Linien/MainLinie_ungenutzt';
import Categories from '../MainMenu/Categories';

import Kontenverwaltung from '../Kontenverwaltung/Kontenverwaltung';
import { MapExperiment } from '../Streetmap/MapExperiment';
import { Aufgaben } from '../Aufgaben/Aufgaben';
import { Notizen } from '../Notizen/Notizen';
import Nutzer from '../Nutzer/Nutzer';

var MonitorApi = require('monitor-api');


export default function Start () {
    const {token, setToken} = useToken();
    const [myApiClient] = useState(new MonitorApi.ApiClient());
    myApiClient.basePath = apiClientPath;
    if (sessionStorage.getItem('user') && sessionStorage.getItem('pw')) {
        let HTTPBasic = myApiClient.authentications['HTTPBasic'];
        HTTPBasic.username = sessionStorage.getItem('user');
        HTTPBasic.password = sessionStorage.getItem('pw');
    }
    const auth = sessionStorage.getItem('token');

    const [section, setSection] = useState('SSPPNNVV');

    return (
        <>
        <BrowserRouter>
            <GeneralHander section={section}/>
            <Routes>
                <Route exact path='/' element = {token ? <Navigate to='/home'/> : <Login myApiClient={myApiClient} setToken={setToken}/>}/>
                <Route path='/home' element={<Categories/>} />
               {token && 
                    <Route path='/*' element={< MenuLinks auth={auth} myApiClient={myApiClient} setSection={setSection}/>} />}
                <Route element = {<KeinZugriff/>} />
            </Routes>
                {/* https://stackoverflow.com/questions/66463284/react-router-warning-route-elements-should-not-change-from-controlled-to-unco
               daher nochmals Routes einbauen und Route drumrum!
               neu: https://reacttraining.com/blog/react-router-v6-pre */}
            <GeneralFooter setToken={setToken} myApiClient={myApiClient}/>
        </BrowserRouter>
        </>
    )
}

function MenuLinks({auth, myApiClient, setSection}) {
    return (
        <Routes>
            <Route path='/stammdaten/*' element={auth.includes('level1') ? <Stammdaten myApiClient={myApiClient} setSection={setSection}/> : < KeinZugriff />} />
            <Route path='/jahreszahlen/*' element={auth.includes('level1') ? <MainJahr myApiClient={myApiClient} setSection={setSection}/>: < KeinZugriff />} />
            {/* TODO: kann linien-und-strecken weg? */}
            <Route path='/linien-und-strecken/*' element={auth.includes('level1') ? <MainLinie myApiClient={myApiClient} setSection={setSection}/> : <KeinZugriff />} />
            <Route path='/aufgaben/*' element={auth.includes('level1') ? <Aufgaben myApiClient={myApiClient} setSection={setSection}/> : <KeinZugriff />} />
            <Route path='/notizen/*' element={auth.includes('level1') ? <Notizen myApiClient={myApiClient} setSection={setSection}/> : <KeinZugriff />} />
            <Route path='/benutzerkonto/*' element={auth.includes('level0') ? <Nutzer myApiClient={myApiClient} setSection={setSection}/> : <KeinZugriff />} />
            <Route path='/datenerfassung/*' element={auth.includes('level0') ? <Datenerfassung myApiClient={myApiClient} setSection={setSection}/> : <KeinZugriff />} />
            <Route path='/reporting/*' element={auth.includes('level0') ? <Reporting myApiClient={myApiClient} setSection={setSection}/> : <KeinZugriff />} />
            <Route path='/support/*' element={auth.includes('level0') ? <Support setSection={setSection}/> : <KeinZugriff />} />
            <Route path="/kontenverwaltung/*" element= {auth.includes('level2') ? <Kontenverwaltung myApiClient={myApiClient} setSection={setSection}/> : <KeinZugriff />} />
            <Route path="/map/*" element= {auth.includes('level2') ? <MapExperiment myApiClient={myApiClient}/> : <KeinZugriff />} />
        </Routes>
    )
}